import fold from '../assets/audio/fold.wav'
import check from '../assets/audio/check.mp3'
import raise from '../assets/audio/raise.mp3'
import call from '../assets/audio/call.mp3'
import bell from '../assets/audio/bell.wav'
import open from '../assets/audio/open.wav'
import clapping from '../assets/audio/clapping.wav'
import message from '../assets/audio/message.wav'
import clock from '../assets/audio/clock.wav'
import {throttle} from "./Hooks";

const playFoldSound = async () => {
    await playSound(fold);
}
export const playFold = throttle(playFoldSound, 1000);

const playCheckSound = async () => {
    await playSound(check);
}
export const playCheck = throttle(playCheckSound, 1000);

const playCallSound = async () => {
    await playSound(call);
}
export const playCall = throttle(playCallSound, 1000);

const playRaiseSound = async () => {
    await playSound(raise);
}
export const playRaise = throttle(playRaiseSound, 1000);

const playBellSound = async () => {
    await playSound(bell);
}
export const playBell = throttle(playBellSound, 1000);

const playOpenSound = async () => {
    await playSound(open);
}
export const playOpen = throttle(playOpenSound, 1000);

const playClappingSound = async () => {
    await playSound(clapping);
}
export const playClapping = throttle(playClappingSound, 1000);

const playMessageSound = async () => {
    await playSound(message);
}
export const playMessage = throttle(playMessageSound, 1000);

const playClockSound = async () => {
    await playSound(clock);
}
export const playClock = throttle(playClockSound, 1000);

const playSound = async (source) => {
    try {
        const audio = new Audio(source);
        await audio.play();
    } catch (e) {
    }
}
